import React from "react";

import PropTypes from "prop-types";

import ContractTypeSelect from "../../common/ContractTypeSelect";

const Filters = ({ onChange, children, filters }) => (
  <div id="contracts-by-type-filters" className="report-filters">
    <ContractTypeSelect
      isMulti
      onChange={onChange("contract_type")}
      value={filters.call_type}
    />
    <input
      type="date"
      value={filters.start_date}
      onChange={(e) => onChange("start_date")(e.target.value)}
    />
    <input
      type="date"
      onChange={(e) => onChange("end_date")(e.target.value)}
      value={filters.end_date}
    />
    {children}
  </div>
);

Filters.propTypes = {
  onChange: PropTypes.func,
  filters: PropTypes.object,
  children: PropTypes.node
};

export default Filters;
